import React from "react";
import { motion } from "framer-motion";
import "../css/Pricing.css";

export default function Pricing() {
  const plans = [
    {
      name: "Starter",
      price: "$49 / month",
      desc: "Ideal for small institutions starting their digital journey.",
      features: [
        "Up to 3 institutions",
        "Core academic modules",
        "Standard analytics",
        "Email support",
      ],
    },
    {
      name: "Professional",
      price: "$99 / month",
      popular: true,
      desc: "Best suited for growing institutions with advanced needs.",
      features: [
        "Up to 10 institutions",
        "Advanced reporting & analytics",
        "Custom branding",
        "LMS integrations",
        "Priority support",
      ],
    },
    {
      name: "Enterprise",
      price: "Custom pricing",
      desc: "Tailored solutions for large-scale and enterprise deployments.",
      features: [
        "Unlimited institutions",
        "Dedicated account manager",
        "Custom workflows & integrations",
        "API access",
        "Personalized onboarding",
      ],
    },
  ];

  return (
    <section className="pricing">
      <div className="pricing-bg" />

      <div className="pricing-wrapper">
        {/* Header */}
        <div className="pricing-header">
          <span className="pricing-label">Pricing</span>

          <h2 className="pricing-title">
            Simple, Transparent <span>Pricing</span>
          </h2>

          <p className="pricing-lead">
            Choose a plan that aligns with your institution’s scale and
            operational needs. Upgrade anytime as you grow.
          </p>
        </div>

        {/* Cards */}
        <div className="pricing-grid">
          {plans.map((plan, index) => (
            <motion.div
              key={index}
              className={`pricing-card ${
                plan.popular ? "highlight" : ""
              }`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.12 }}
              viewport={{ once: true }}
            >
              {plan.popular && (
                <div className="pricing-badge">Recommended</div>
              )}

              <h3 className="plan-name">{plan.name}</h3>
              <p className="plan-desc">{plan.desc}</p>

              <div className="plan-price">{plan.price}</div>

              <ul className="plan-features">
                {plan.features.map((feature, i) => (
                  <li key={i}>{feature}</li>
                ))}
              </ul>

              <button className="plan-action">
                {plan.price === "Custom pricing"
                  ? "Request Quote"
                  : "Get Started"}
              </button>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
